import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getAccountMetrics } from '@/services/composer-dashboard/get-account-metrics';
import { AccountMetricsResponse } from '@/types/composer-dashboard';
import { useOrgStore } from '@/stores/org-store';

export function useGetAccountMetrics(
  options?: Omit<
    UseQueryOptions<AccountMetricsResponse, Error>,
    'queryKey' | 'queryFn'
  >,
) {
  const { currentOrg } = useOrgStore();
  const orgId = currentOrg?.orgid;

  return useQuery<AccountMetricsResponse, Error>({
    queryKey: ['account-metrics', orgId],
    queryFn: () => getAccountMetrics(orgId!),
    staleTime: 60 * 1000,
    ...options,
    enabled: !!orgId && (options?.enabled ?? true),
  });
}
